import TaggedModal from '@components/TaggedModal';
import { useDeactivateGradingLimit } from '@modules/gradingLimits/src/gradingLimitsMutations';
import { GradingLimitsQueryKeys } from '@modules/gradingLimits/src/gradingLimitsQueries';
import { Descriptions, Typography } from 'antd';
import { FC } from 'react';
import { useQueryClient } from 'react-query';

interface DeactivateGradingLimitsModalProp {
  closeModal: () => void;
  showModal: boolean;
  selectedGrade: GradingLimits.GradingLimitsList;
}

const DeactivateGradingLimitsModal: FC<DeactivateGradingLimitsModalProp> = (props) => {
  const { closeModal, showModal, selectedGrade } = props;

  const { Paragraph } = Typography;

  const { mutate, isLoading } = useDeactivateGradingLimit(closeModal, selectedGrade);

  const formDataDeactivateGradingLimit = () => {
    mutate({ gradingId: selectedGrade.gradingId });
  };

  const queryClient = useQueryClient();
  const onCancel = () => {
    queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
    closeModal();
  };

  return (
    <TaggedModal
      open={showModal}
      tag="deactivateGradingLimit"
      title="Deactivate Grading Limit"
      onCancel={onCancel}
      okText="Deactivate"
      onOk={formDataDeactivateGradingLimit}
      destroyOnHidden
      okButtonProps={{ danger: true, loading: isLoading }}
      centered
    >
      <Paragraph>Are you sure you wish to deactivate this grade:</Paragraph>
      <Descriptions column={1} labelStyle={{ fontWeight: 'bold' }} contentStyle={{ fontWeight: 'bold' }}>
        <Descriptions.Item label="Grade">{selectedGrade.grade}</Descriptions.Item>
        <Descriptions.Item label="Suggested Absolute Limit">{selectedGrade.suggestedAbsoluteLimit}</Descriptions.Item>
        <Descriptions.Item label="Suggested % Limit">{selectedGrade.suggestedLimitPercentage}</Descriptions.Item>
        <Descriptions.Item label="Suggested Theme">{selectedGrade.suggestedThemeName}</Descriptions.Item>
      </Descriptions>
    </TaggedModal>
  );
};

export default DeactivateGradingLimitsModal;
